export const CREATE_EVENT = "CREATE_EVENT";
export const RETRIEVE_EVENT = "RETRIEVE_EVENT";
export const RETRIEVESINGLE_EVENT = "RETRIEVESINGLE_EVENT";
export const UPDATE_EVENT = "UPDATE_EVENT";
export const DELETE_EVENT = "DELETE_EVENT";


